import { useMsal } from '@azure/msal-react';
import { useRecoilValue } from 'recoil';
import { sessionDataAtom } from '~/state/atoms/sessionAtoms';

/**
 * Resolves the current user's reviewer name for approval operations.
 *
 * Priority order:
 * 1. Session username (set during login)
 * 2. Active MSAL account display name
 * 3. Fallback string 'unknown'
 */
export function useReviewer(): string {
    const { instance } = useMsal();
    const sessionData = useRecoilValue(sessionDataAtom);

    return (
        sessionData?.username ?? instance?.getActiveAccount()?.name ?? 'unknown'
    );
}
